import React, { ClassAttributes, } from 'react';
import { Provider, connect, } from 'react-redux';
import { ThemeProvider, } from 'emotion-theming';
import ReactResizeDetector from 'react-resize-detector';
import SewWidgetComponent from '../components/SewWidget';
import configureStore, { InitialData, } from '../../sew-core/store';
import { AppState, } from '../../sew-core/types';
import {
  dataReceived,
} from '../../sew-core/actions/index';
import GlobalOverlay from './GlobalOverlay';

export interface SewWidgetProps<T> extends ClassAttributes<any> {
  initialData: InitialData;
  queryParams?: any;
  initialRender?: boolean;
}

const mapStateToProps = (state: AppState) => ({
  vehicle: state.vehicle,
  consumerReviewAndRating: state.consumerReviewAndRating,
  expertReviewAndRating: state.expertReviewAndRating,
  vehicleAward: state.vehicleAward,
  accountInfoData: state.accountInfoData,
  queryParams: state.app.config.queryParams,
  errors: state.errors,
});

const mapDispatchToProps = (dispatch) => ({
  dataReceived: (panelsWithData) => dispatch(dataReceived(panelsWithData)),
});

const SewWidget = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SewWidgetComponent);

const SewWidgetWithTheme = ({ initialData, initialRender, }: SewWidgetProps<any>) => {
  const { theme, } = initialData;
  return (
    <ThemeProvider theme={{ ...theme, }}>
      <SewWidget initialRender={initialRender} />
      <GlobalOverlay />
    </ThemeProvider>
  );
};

export default ({ initialData, initialRender, }: SewWidgetProps<any>) => {
  // set up initial store state with data received from backend
  const store = configureStore(initialData);
  return (
    <Provider store={store}>
      <ReactResizeDetector handleWidth handleHeight refreshMode="throttle" refreshRate={500}>
        <SewWidgetWithTheme initialData={initialData} initialRender={initialRender} />
      </ReactResizeDetector>
    </Provider>
  );
};
